<template>
    <div class="todoList-module">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex-y-center flex-start">
            <div v-if="postId != 42 && postId != 2" class="select-item flex-between flex-y-center flex-1 flex-start" @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="interval"></div>
        <div class="cardType">{{ serviceName }}</div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getDetailList" :offset="20" :immediate-check="false">
                    <div class="list-item flex-col flex-y-center" v-for="item, index in cardPropertyList" :key="index">
                        <div class="list-item-top flex-between flex-y-center" @click="toDetail(item.custId, item.phone)">
                            <img class="head-img" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" alt="" />
                            <div class="flex-1 top-tit">{{ item.name }}</div>
                            <van-icon name="arrow" class="arrow" />
                        </div>
                        <div class="list-item-bottom flex-between flex-y-center">
                            <div class="bottom-item">
                                资产：<span class="bottom-txt">{{ item.customerPropertyAmount }}万</span>
                            </div>
                            <div class="bottom-item">
                                次数：<span class="bottom-txt">{{ item.count }}</span>
                            </div>
                            <div class="bottom-item ">
                                健康顾问：<span class="bottom-txt">{{ item.doctorAdviserName }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
            <picker title="全部员工" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange"></picker>
        </van-popup>

        <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
            <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import Picker from '@/components/Picker';
    import { Toast } from 'vant'
    import { getCookie } from '@/utils'

    export default {
        name: 'ksAssetItem',
        components: {
            Picker
        },
        data() {
            return {
                postId: 0,
                searchStr: '',  //搜索关键字
                cardId: '',
                serviceName: '',
                loading: false,    // 加载
                finished: false,    // 结束加载
                refreshing: false,   // 刷新
                page: 1, // 分页
                total: 0,
                cardPropertyList: [],// 待办列表
                showEmployeePopup: false, // 选择员工弹窗
                showSortPopup: false, // 排序
                sortList: [], // 排序
                checkedSort: null,//所选排序
                employeeList: [], // 员工
                checkedEmployee: { id: 0, name: '全部员工' },
                dimension: 0, //区分生美医美 1 生美 2 医美
                type: '' // 项目类型
            }
        },
        mounted() {
            this.serviceName = this.$route.query.serviceName
            this.cardId = this.$route.query.cardId
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.type = this.$route.query.type

            this.init();
        },
        methods: {
            onLoad() {
                // 初始化data的值
                Object.assign(this.$data, this.$options.data())
                this.init();
            },
            async init() {
                await this.getEmpList()
                await this.getSortList()
                this.getDetailList()
            },
            // 获取列表
            getDetailList() {
                let url = '/debt/storeServiceCustomerProperty' // 护理请求
                if (this.type == 4) {
                    url = '/debt/storeCouponCustomerProperty' // 券余请求
                }
                let params = {
                    propertySortType: this.checkedSort.id,
                    limit: this.limit,
                    page: this.page,
                    id: this.$route.query.id || '',
                    storeId: this.$route.query.storeId || '',
                    cateType: this.type,
                    searchStr: this.searchStr,
                    serviceSku: this.$route.query.serviceSku,
                    employeeId: this.checkedEmployee.id
                }
                request({
                    url: url,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.cardPropertyList = this.page == 1 ? res.data.list : this.cardPropertyList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.refreshing = false;
                        if (this.cardPropertyList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 获取员工列表
            getEmpList() {
                return request({
                    url: "/sys/params/selectByStoreTreasure",
                    method: "get",
                    params: {
                        asset: 1,
                        storeId: this.$route.query.storeId,
                        id: this.$route.query.id,
                    }
                })
                    .then((res) => {
                        this.employeeList = res.data
                        this.checkedEmployee = this.employeeList[0] //默认全部

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 获取排序
            getSortList() {
                return request({
                    url: "/debt/cardCustomerSortList",
                    method: "get",
                })
                    .then((res) => {
                        this.sortList = res.data
                        this.checkedSort = this.sortList[0] //默认全部
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            //搜索
            onSearch() {
                this.page = 1
                this.getDetailList();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.page = 1
                this.getDetailList();
            },
            // 刷新
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.cardPropertyList = [];
                this.refreshing = false;
                this.getDetailList();
            },
            // 弹窗
            selectEmployeePopup() {
                this.showEmployeePopup = true
            },
            selectSortPopup() {
                this.showSortPopup = true
            },
            onEmployeeChange(data) {
                this.checkedEmployee = data
                this.showEmployeePopup = false
                this.onRefresh()
            },
            onSortChange(data) {
                this.showSortPopup = false
                this.checkedSort = data
                this.onRefresh()
            },
            //详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
        },
    }
</script>

<style scoped lang="less">
    .ml-20 {
        margin-left: 20px;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .interval {
        width: 750px;
        height: 20px;
        background: #f9fafc;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0);
    }

    .main-box {
        padding: 30px;
        height: 100%;
    }

    .select-box {
        z-index: 99;
        padding: 30px;
        padding-top: 0;

        .select-item {
            margin-right: 15px;
        }

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .cardType {
        height: 48px;
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        line-height: 48px;
        margin: 30px 0 30px 30px;
    }

    .list-box {
        overflow-y: auto;
        height: calc(100vh - 290px);
        padding: 30px;
        padding-top: 0;

        .list-item {
            width: 690px;
            height: 200px;
            background: #fafafe;
            border-radius: 20px;
            padding: 20px 30px 20px 20px;
            margin-bottom: 20px;

            .list-item-top {
                width: 100%;

                .head-img {
                    width: 90px;
                    height: 90px;
                    border-radius: 50%;
                    margin-right: 20px;
                }

                .top-tit {
                    font-size: 30px;
                    font-weight: 700;
                    color: #35434c;
                }

                .arrow {
                    font-size: 32px;
                    color: #cccccc;
                }
            }

            .list-item-bottom {
                width: 100%;
                margin-top: 30px;

                .bottom-item {
                    // width: 35%;
                    height: 40px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #a0acb5;

                    .bottom-txt {
                        font-size: 28px;
                        font-weight: 700;
                        color: #35434c;
                    }

                    .bottom-txt.red {
                        color: #ff7777;
                    }
                }
            }
        }
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.van-popup__close-icon--top-right) {
        top: 50px;
    }

    :deep(.search-button.van-search) {
        padding: 30px 30px 30px 30px;
    }

    :deep(.search-button .van-icon) {
        font-size: 28px;
    }

    :deep(.search-button .van-search__content) {
        padding-left: 28px !important;
    }

    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>
